/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { OfferProductStructure } from '../models/OfferProductStructure';
import type { PaginatedOfferProductStructureList } from '../models/PaginatedOfferProductStructureList';
import type { PatchedOfferProductStructure } from '../models/PatchedOfferProductStructure';

import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';

export class OffersProductStructuresService {

    constructor(public readonly httpRequest: BaseHttpRequest) {}

    /**
     * @returns PaginatedOfferProductStructureList
     * @throws ApiError
     */
    public offersProductStructuresList({
        page,
        pageSize,
    }: {
        /**
         * A page number within the paginated result set.
         */
        page?: number,
        /**
         * Number of results to return per page.
         */
        pageSize?: number,
    }): CancelablePromise<PaginatedOfferProductStructureList> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/offers-product-structures/',
            query: {
                'page': page,
                'page_size': pageSize,
            },
        });
    }

    /**
     * @returns OfferProductStructure
     * @throws ApiError
     */
    public offersProductStructuresCreate({
        requestBody,
    }: {
        requestBody: OfferProductStructure,
    }): CancelablePromise<OfferProductStructure> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/offers-product-structures/',
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @returns OfferProductStructure
     * @throws ApiError
     */
    public offersProductStructuresRetrieve({
        id,
    }: {
        /**
         * A unique integer value identifying this offer product structure.
         */
        id: number,
    }): CancelablePromise<OfferProductStructure> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/offers-product-structures/{id}/',
            path: {
                'id': id,
            },
        });
    }

    /**
     * @returns OfferProductStructure
     * @throws ApiError
     */
    public offersProductStructuresUpdate({
        id,
        requestBody,
    }: {
        /**
         * A unique integer value identifying this offer product structure.
         */
        id: number,
        requestBody: OfferProductStructure,
    }): CancelablePromise<OfferProductStructure> {
        return this.httpRequest.request({
            method: 'PUT',
            url: '/offers-product-structures/{id}/',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @returns OfferProductStructure
     * @throws ApiError
     */
    public offersProductStructuresPartialUpdate({
        id,
        requestBody,
    }: {
        /**
         * A unique integer value identifying this offer product structure.
         */
        id: number,
        requestBody?: PatchedOfferProductStructure,
    }): CancelablePromise<OfferProductStructure> {
        return this.httpRequest.request({
            method: 'PATCH',
            url: '/offers-product-structures/{id}/',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @returns void
     * @throws ApiError
     */
    public offersProductStructuresDestroy({
        id,
    }: {
        /**
         * A unique integer value identifying this offer product structure.
         */
        id: number,
    }): CancelablePromise<void> {
        return this.httpRequest.request({
            method: 'DELETE',
            url: '/offers-product-structures/{id}/',
            path: {
                'id': id,
            },
        });
    }

}
